import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import * as css from "./setup-welcome-overlay.module.css";

/**
 * Full-screen orange diagonal wash anchored at the bottom-right
 * corner. Rendered as a sibling to the dock so it can cover the
 * whole viewport without affecting the dock's flex layout.
 * `pointer-events: none` so clicks pass through to content beneath.
 */
export const SetupWelcomeGradient = memo(function SetupWelcomeGradient() {
  return <div aria-hidden className={css.gradient} />;
});

export interface SetupWelcomePanelProps {
  /** "Got it" — dismisses the overlay and persists so it doesn't return. */
  onDismiss: () => void;
}

/**
 * Copy + dismiss-button panel. Designed to live inside the bottom-
 * right dock alongside the setup widget — the dock's `align-items:
 * center` keeps this panel vertically aligned with the widget's
 * vertical center regardless of widget height.
 */
export const SetupWelcomePanel = memo(function SetupWelcomePanel({
  onDismiss,
}: SetupWelcomePanelProps) {
  return (
    <div aria-live="polite" className={css.panel} role="status">
      <h2 className={css.title}>Welcome to Reclaim.</h2>
      <p className={css.subtitle}>
        Use the checklist to turn on AI evidence for your store.
      </p>
      <div className={css.buttonRow}>
        <RedoButton
          buttonClassName={css.button}
          hierarchy="secondary"
          onClick={onDismiss}
          size="sm"
          text="Got it"
        />
      </div>
    </div>
  );
});
